export default "__VITE_ASSET__b372c8fd__"